import { useAgTechAuthContext } from "@agtech/core/auth/AgTechAuthContext";
import { AgTechDataAction } from "@agtech/core/data/actions/AgTechDataActions";
import { useAgTechApiPutRequest } from "@agtech/core/data/http/AgTechApiPutRequests";
import { AgTechUpdateUserProfileDTO, AgTechUserProfileAddress, AgTechUserProfileRoute } from "./AgTechUserProfileData";
import { UserDataGetMyProfileQuery } from "./AgTechUserProfileQueries";
import { UserDataGetUserDetailsQuery } from "./AgTechUserQueries";

/// Actions on the signed-in user's own identity record. Email is intentionally not editable here: the
/// identity server applies it without confirmation and operation invitations are matched on it.

export const useUserDataUpdateProfileAction = (route: AgTechUserProfileRoute): AgTechDataAction<AgTechUpdateUserProfileDTO, any> => {
    const updateProfileRequest = useAgTechApiPutRequest<AgTechUpdateUserProfileDTO, any>();
    const currentUserId = useAgTechAuthContext().user.id;

    return {
        name: 'UpdateMyProfile',
        getConfiguration: () => ({
            actionExecutionMessage: 'Updating your profile...',
            actionConfirmationMessage: 'Successfully updated your profile'
        }),
        action: async props => updateProfileRequest.put({
            path: route,
            postedData: {
                firstName: props.submittedEntity.firstName,
                lastName: props.submittedEntity.lastName,
                phoneNumber: props.submittedEntity.phoneNumber
            }
        }),
        onSuccess: async props => {
            props.invalidateQuery({ query: UserDataGetMyProfileQuery, queryContext: { route } });

            // The header shows the user's name, so refresh it too
            props.invalidateQuery({ query: UserDataGetUserDetailsQuery, queryContext: { userId: currentUserId } });
        }
    }
}

export const useUserDataUpdateAddressAction = (route: AgTechUserProfileRoute): AgTechDataAction<AgTechUserProfileAddress, any> => {
    const updateAddressRequest = useAgTechApiPutRequest<AgTechUserProfileAddress, any>();

    return {
        name: 'UpdateMyAddress',
        getConfiguration: () => ({
            actionExecutionMessage: 'Updating your address...',
            actionConfirmationMessage: 'Successfully updated your address'
        }),
        action: async props => updateAddressRequest.put({
            path: `${route}/Address`,
            postedData: props.submittedEntity
        }),
        onSuccess: async props => {
            props.invalidateQuery({ query: UserDataGetMyProfileQuery, queryContext: { route } });
        }
    }
}
